const ensureNever = (x: never): never => x

const notEmpty = <T>(value: T | null | undefined): value is T => {
  return value !== null && value !== undefined
}
export { ensureNever, notEmpty }
